import { FullPageScreen } from "@/lib/Components/Screens/FullPageScreen";
import { CallbackLeadTable } from "@/app/CallbackLeads/Components/CallbackLeadTable";
import { OutgoingCallTally } from "@/app/CallbackLeads/Components/OutgoingCallTally";
import {
  CallbackLeadList,
  callbackLeadLists,
} from "@/app/CallbackLeads/Routes/callbackLeadRoutes";
import {
  Navbar,
  NavbarItemLink,
  NavbarSection,
} from "@/components/catalyst/navbar";
import { Badge } from "@/components/catalyst/badge";
import { callbackLeadCountsQuery } from "@/app/CallbackLeads/GraphQL/callbackLeadCountsQuery";
import { useGqlQuery } from "@/lib/GraphQLCodegen/fetcher";
import { useMatch, useMatchRoute } from "@tanstack/react-router";
import { useTranslations } from "use-intl";

export function CallbackLeadsScreen() {
  const { search } = useMatch({
    from: "/$tenant/$orgId/supplier/{-$supplierId}/callbacks",
  });

  return (
    <FullPageScreen>
      <OutgoingCallTally />
      <Header />
      <CallbackLeadTable list={search.list} />
    </FullPageScreen>
  );
}

function Header() {
  "use no memo";

  const t = useTranslations("callbackLead");
  const matchRoute = useMatchRoute();
  const { data } = useGqlQuery(callbackLeadCountsQuery, {});

  const counts: Partial<Record<CallbackLeadList, number>> = {
    due: data?.callbackLeadCounts.pending,
    snoozed: data?.callbackLeadCounts.snoozed,
  };

  return (
    <div className="relative border-gray-200 sm:border-b sm:pb-0">
      <h3 className="text-base font-semibold leading-6 text-gray-900">
        {t("title")}
      </h3>
      <Navbar className="-mb-px">
        <NavbarSection>
          {callbackLeadLists.map((list: CallbackLeadList) => (
            <NavbarItemLink
              key={list}
              current={
                !!matchRoute({
                  to: "/$tenant/$orgId/supplier/{-$supplierId}/callbacks",
                  search: { list },
                })
              }
              to="/$tenant/$orgId/supplier/{-$supplierId}/callbacks"
              params={(prev) => prev}
              search={{ list }}
            >
              {t(`filters.${list}`)}
              {counts[list] ? (
                <Badge
                  className="py-0"
                  color={list === "due" ? "amber" : "zinc"}
                >
                  {counts[list]}
                </Badge>
              ) : null}
            </NavbarItemLink>
          ))}
        </NavbarSection>
      </Navbar>
    </div>
  );
}
